import { Factory, trait } from 'miragejs';
import { VfdContactMethodKind } from 'garaje/models/vfd-contact-method';
import { faker } from '@faker-js/faker';
import { dasherize } from '@ember/string';

export default Factory.extend({
  contactPriority: 0,

  asBackupContact: trait({
    afterCreate(contactMethod, server) {
      if (contactMethod.contactPriority) return; // if this was created with an explicit priority, don't override it

      // find all contact methods for the same location
      const contactMethods = server.schema.vfdContactMethods.where({ configurationId: contactMethod.configurationId });
      const highestPriorityValue = Math.max(...contactMethods.models.map((c) => c.contactPriority));

      contactMethod.update({ contactPriority: highestPriorityValue + 1 });
    },
  }),

  // By default, new models are initialized with contactPriority: 0, so this trait is a bit redundant,
  // but it does make primary vs. backup more explicit in tests.
  asPrimaryContact: trait({
    contactPriority: 0,
  }),

  asSlack: trait({
    kind: VfdContactMethodKind.Slack,
    metadata() {
      const id = this.channelId || faker.string.uuid();
      delete this.channelId;
      const name = this.channelName || dasherize(faker.commerce.department().toLowerCase());
      delete this.channelName;

      return {
        'channel-id': id,
        'channel-name': name,
      };
    },
  }),

  asTeams: trait({
    kind: VfdContactMethodKind.Teams,
    metadata() {
      const id = this.channelId || faker.string.uuid();
      delete this.channelId;
      const name = this.channelName || dasherize(faker.commerce.department().toLowerCase());
      delete this.channelName;

      return {
        'channel-id': id,
        'channel-name': name,
      };
    },
  }),

  asUser: trait({
    kind: VfdContactMethodKind.EnvoyUser,
    metadata: () => ({}),
  }),
});
